/**
 * Publieke meetfunctie voor B2B-campagnes: registreert dat een bedrijf het
 * aanmeldformulier heeft geopend na een campagnelink. Werkt uitsluitend met het
 * kliktoken uit de e-mail en geeft nooit gegevens terug.
 */
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

export const trackB2bSignupStart = createServerFn({ method: "POST" })
  .inputValidator((d: unknown) => z.object({ token: z.string().min(16).max(64) }).parse(d))
  .handler(async ({ data }) => {
    if (!/^[a-f0-9]{16,64}$/i.test(data.token)) return { ok: false };
    try {
      const { registerB2bSignupStart } = await import("./b2b-send.server");
      await registerB2bSignupStart(data.token);
    } catch {
      // Meten mag een aanmelding nooit blokkeren.
    }
    return { ok: true };
  });
